import React from 'react';
import { Check, X } from 'lucide-react';

const PasswordStrengthMeter = ({ password, isVisible = true }) => {
  if (!isVisible) return null;

  const criteria = [
    { label: 'At least 8 characters', test: (pwd) => pwd.length >= 8 },
    { label: 'Contains uppercase letter', test: (pwd) => /[A-Z]/.test(pwd) },
    { label: 'Contains lowercase letter', test: (pwd) => /[a-z]/.test(pwd) },
    { label: 'Contains number', test: (pwd) => /\d/.test(pwd) },
    { label: 'Contains special character', test: (pwd) => /[!@#$%^&*(),.?":{}|<>]/.test(pwd) },
  ];

  const metCriteria = criteria.filter(criterion => criterion.test(password));
  const strength = metCriteria.length;

  const getStrengthColor = () => {
    if (strength <= 2) return 'text-error';
    if (strength <= 3) return 'text-warning';
    if (strength <= 4) return 'text-primary';
    return 'text-success';
  };

  const getStrengthLabel = () => {
    if (strength <= 2) return 'Weak';
    if (strength <= 3) return 'Fair';
    if (strength <= 4) return 'Good';
    return 'Strong';
  };

  const getStrengthBarColor = () => {
    if (strength <= 2) return 'bg-error';
    if (strength <= 3) return 'bg-warning';
    if (strength <= 4) return 'bg-primary';
    return 'bg-success';
  };

  return (
    <div className="mt-3 p-3 bg-surface rounded-lg border border-accent-200">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-medium text-accent-700">Password Strength</span>
        <span className={`text-sm font-semibold ${getStrengthColor()}`}>
          {getStrengthLabel()}
        </span>
      </div>
      
      {/* Strength Bar */}
      <div className="w-full bg-accent-200 rounded-full h-2 mb-3">
        <div 
          className={`h-2 rounded-full transition-all duration-300 ${getStrengthBarColor()}`}
          style={{ width: `${(strength / 5) * 100}%` }}
        />
      </div>

      {/* Criteria List */}
      <div className="space-y-1">
        {criteria.map((criterion, index) => {
          const isMet = criterion.test(password);
          return (
            <div key={index} className="flex items-center text-xs">
              <div className={`mr-2 ${isMet ? 'text-success' : 'text-accent-400'}`}>
                {isMet ? <Check size={14} /> : <X size={14} />}
              </div>
              <span className={isMet ? 'text-success' : 'text-accent-600'}>
                {criterion.label}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PasswordStrengthMeter;